import PropTypes from "prop-types";
import React from "react";
import { useReducer } from "react";

export const DateInput = ({ property1, className, placeholder, onChange ,error, value, noMargin, maxDate }) => {
  const [state, dispatch] = useReducer(reducer, {
    property1: property1 || "empty",
  });

  return (
    <div className={!noMargin?"mb-3":""}>
      <input
        className={`email-input email d-block ${state.property1} ${className}`}
        placeholder={placeholder}
        onClick={() => {
          dispatch("click");
        }}
        type="text"
        onFocus={(e) => (e.target.type = "date")}
        onBlur={(e) => (e.target.type = "text")}
        onChange={(e)=>onChange(e?.target?.value)}
        defaultValue={value}
        max={maxDate}
      />
      <p className="text-danger h6 position-absolute  text-start">{error}</p>
    </div>
  );
};

function reducer(state, action) {
  switch (action) {
    case "click":
      return {
        ...state,
        property1: "email",
      };
    default:
      break;
  }

  return state;
}

DateInput.propTypes = {
  property1: PropTypes.oneOf(["empty", "email"]),
};
